import { render, staticRenderFns } from "./rePass.vue?vue&type=template&id=b8b843a6&scoped=true&"
import script from "./rePass.vue?vue&type=script&lang=js&"
export * from "./rePass.vue?vue&type=script&lang=js&"
import style0 from "./rePass.vue?vue&type=style&index=0&id=b8b843a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b843a6",
  null
  
)

export default component.exports